<template>
  <div class="ad-container">
    <!-- 企业单位 -->
    <div class="padding-lr-16 distance">
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p class="titleOne">抬头类型</p>
          <p>
            <van-radio-group
              v-model="enterFrom.titleType"
              class="flex justify-between"
            >
              <van-radio class="title" icon-size="16px" name="0"
                >企业单位</van-radio
              >
              <van-radio name="1" icon-size="16px">个人/非企业</van-radio>
            </van-radio-group>
          </p>
        </div>
        <div v-if="enterFrom.titleType == 0">
          <van-cell-group>
            <van-field
              v-model="enterFrom.name"
              required
              label="公司名称"
              placeholder="请输入公司名称"
              :rules="rules.name"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="enterFrom.dutyParagra"
              required
              label="公司税号"
              placeholder="填写纳税人识别号"
              :rules="rules.dutyParagra"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="enterFrom.address"
              required
              label="注册地址"
              placeholder="请填写公司注册地址"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="enterFrom.telphone"
              required
              label="注册电话"
              placeholder="请填写公司注册电话"
              :rules="rules.telphone"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="enterFrom.bank"
              required
              label="开户银行"
              placeholder="请填写公司开户银行"
              :rules="rules.bank"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="enterFrom.account"
              required
              label="银行账号"
              placeholder="请填写银行账号"
              :rules="rules.account"
            />
          </van-cell-group>
        </div>
        <!-- 个人/非企业 -->
        <div v-if="enterFrom.titleType == 1">
          <van-cell-group>
            <van-field
              v-model="enterFrom.name"
              required
              label="姓名"
              placeholder="请输入姓名"
            />
            <van-field
              v-model="enterFrom.telphone"
              label="电话号码（选填）"
              placeholder="请输入电话号码"
              :rules="rules.telphone"
            />
            <van-field
              v-model="enterFrom.email"
              label="邮箱（选填）"
              placeholder="请输入邮箱"
              :rules="rules.email"
            />
          </van-cell-group>
        </div>
        <van-cell center title="设置为默认抬头">
          <template #right-icon>
            <van-switch v-model="checked" size="24" />
          </template>
        </van-cell>
      </div>
    </div>
    <div class="distance-left-right">
      <van-button
        v-if="enterFrom.titleType == 0"
        type="warning"
        class="button"
        @click="submitTitle('0')"
        >保存</van-button
      >
      <van-button
        v-if="enterFrom.titleType == 1"
        type="warning"
        class="button"
        @click="submitTitle('1')"
        >保存</van-button
      >
    </div>
  </div>
</template>
<script>
import { insert } from 'api/invoice'
export default {
  data () {
    return {
      // 校验
      rules: {
        email: [
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'onBlur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'onBlur'
          }
        ],
        dutyParagra: [
          {
            required: true,
            pattern: /^([159Y]{1})([1239]{1})([0-9ABCDEFGHJKLMNPQRTUWXY]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-90-9ABCDEFGHJKLMNPQRTUWXY])$/,
            message: '税号格式错误',
            trigger: 'onBlur'
          }
        ],
        telphone: [
          {
            pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'onBlur'
          }
        ],
        bank: [
          {
            required: true,
            message: '请填写公司开户银行',
            trigger: 'onBlur'
          }
        ],
        account: [
          {
            required: true,
            message: '请填写银行账号',
            trigger: 'onBlur'
          }
        ]
      },
      // 企业单位
      enterFrom: {
        titleType: '0',
        name: '',
        dutyParagra: '',
        address: '',
        telphone: '',
        bank: '',
        account: '',
        email: ''
      },
      checked: false,
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      value: '',
      show: false
    }
  },
  methods: {
    submitTitle (type) {
      const emailVerigy = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const dutyParagra = /^([159Y]{1})([1239]{1})([0-9ABCDEFGHJKLMNPQRTUWXY]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-90-9ABCDEFGHJKLMNPQRTUWXY])$/
      const phoneVerigy = /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/

      let params = {}
      if (type === '0') {
        if (!this.enterFrom.name) {
          this.$toast('请填写公司名称')
          return
        } else if (!this.enterFrom.dutyParagra.match(dutyParagra)) {
          this.$toast('税号格式错误')
          return
        } else if (!this.enterFrom.address) {
          this.$toast('请填写注册地址')
          return
        } else if (!this.enterFrom.telphone.match(phoneVerigy)) {
          this.$toast('请正确填写电话号码')
          return
        } else if (!this.enterFrom.bank) {
          this.$toast('请填写开户银行')
          return
        } else if (!this.enterFrom.account) {
          this.$toast('请填写银行账号')
          return
        }
        params = {
          invoiceType: this.enterFrom.titleType,
          headerName: this.enterFrom.name,
          taxNumber: this.enterFrom.dutyParagra,
          address: this.enterFrom.address,
          mobile: this.enterFrom.telphone,
          openBank: this.enterFrom.bank,
          openBankNumber: this.enterFrom.account,
          checked: this.checked,
          email: this.email
        }
      }
      if (type === '1') {
        if (!this.enterFrom.name) {
          this.$toast('请填写姓名')
          return
        }
        if (
          this.enterFrom.telphone &&
          !this.enterFrom.telphone.match(phoneVerigy)
        ) {
          this.$toast('电话号码格式不正确')
          return
        }
        if (this.enterFrom.email && !this.enterFrom.email.match(emailVerigy)) {
          this.$toast('邮箱格式不正确')
          return
        }
        params = {
          invoiceType: this.enterFrom.titleType,
          headerName: this.enterFrom.name,
          mobile: this.enterFrom.telphone,
          email: this.enterFrom.email
        }
      }
      insert(params).then(res => {
        this.insert = res
        this.$bus.$emit('select')
        this.$router.back()
      })
    }
  }
}
</script>
<style scoped>
.ad-body-box {
  background-color: #fff;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 0 12px 0 #eee;
  padding: 0 8px;
}
.titleOne {
  margin-left: 20px;
}
.title {
  margin-left: -10px;
}
.notice {
  margin-top: 16px;
}
.bg-title {
  background-color: #fbd3926b;
  width: 100%;
}
.distance {
  margin-top: 20px;
}
.list {
  margin-top: 17px;
}
.button {
  border-radius: 50px;
  width: 90%;
  margin-top: 20px;
  background-color: #ff7307;
  margin-left: 16px;
}
.btn {
  position: absolute;
  text-align: center;
  bottom: 0;
  font-size: 16px;
  color: #ffffff;
  margin: 25px 0;
  width: 335px;
  height: 45px;
  line-height: 35px;
  background: #e0e0e0;
  border-radius: 5px;
  background-color: #1b68fd;
  left: 50%;
  transform: translateX(-50%);
}
.distance-select {
  padding: 10px;
}
</style>
